// userDetailAndAction.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    faRightFromBracket,
    faUserAlt,
    faCreditCard,
    faGauge,
    faCaretDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PoweredByInfo } from './powereByComponent';
import { useAuth } from '../context/AuthContext';
import {
    Features,
    OtherFeatures,
    isFeatureEnabled,
    toSentenceCase,
} from '@quyva/common';
import { useFeatureFlags } from '../context';
import { Dropdown } from '@quyva/shared-ui';

export const UserDetailAndAction = (props) => {
    const user = JSON.parse(localStorage.getItem('current'));
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { featureFlagsData } = useFeatureFlags();

    if (!user) {
        return null;
    }

    const handleLogoutAction = async () => {
        await logout();
    };

    const dropDownItems = [];
    const currentPlanName = props.planName || 'FREE';

    dropDownItems.push({
        label: 'Manage Plan',
        icon: faCreditCard,
        action: () => {
            navigate('/current-plan'); // Changed this line to navigate to current-plan
        },
    });

    if (
        isFeatureEnabled(
            [Features.OTHERS, OtherFeatures.LOGOUT_BUTTON],
            featureFlagsData
        )
    ) {
        dropDownItems.push({
            label: 'Logout',
            icon: faRightFromBracket,
            action: handleLogoutAction,
            type: 'danger',
        });
    }

    // Custom Trigger Button
    const UserInfoButtonTrigger = (
        <button
            type='button'
            className='w-full flex items-center justify-between p-2 rounded-xl text-left  hover:bg-backgrounds-primary100 border border-transparent hover:border-backgrounds-primary200 focus:outline-none'
        >
            <div className='flex items-end min-w-0'>
                <div className='flex-shrink-0 w-10 h-10 rounded-full bg-backgrounds-white border border-backgrounds-primary200 flex items-center justify-center text-sky-300 font-semibold text-xl'>
                    {user.username.charAt(0).toUpperCase()}
                </div>
                <div className='w-full ml-3 truncate text-base'>
                    <div className='w-full flex justify-end items-center text-xs text-texts-secondary300 font-semibold'>
                        <span
                            className='px-2 py-0.5 bg-backgrounds-primary100 rounded-full'
                            title='Current Plan'
                        >
                            {toSentenceCase(currentPlanName)}
                        </span>
                    </div>
                    <div className='w-full font-semibold truncate text-base text-texts-secondary300'>
                        {user.username}
                    </div>
                    <div className='w-full text-sm truncate text-texts-secondary300'>
                        {user.email || ''}
                    </div>
                </div>
            </div>

            <FontAwesomeIcon
                icon={faCaretDown}
                className='ml-2 text-texts-secondary300 drop-shadow-sm'
            />
        </button>
    );

    const userDropdownEnabled = isFeatureEnabled(
        [Features.OTHERS, OtherFeatures.USER_INFORMATION],
        featureFlagsData
    );

    return (
        <div className='flex flex-col justify-between text-texts-secondary300 w-full h-full truncate'>
            <div className='w-full'>
                {userDropdownEnabled && (
                    <Dropdown
                        dropDownList={dropDownItems}
                        placement='topRight'
                        listTitleText='Account Actions'
                        triggerComponent={UserInfoButtonTrigger}
                    />
                )}
            </div>

            {isFeatureEnabled(
                [Features.OTHERS, OtherFeatures.POWERED_BY],
                featureFlagsData
            ) && (
                <div className='flex w-full items-center justify-center truncate mt-auto pb-1 px-2'>
                    <PoweredByInfo />
                </div>
            )}
        </div>
    );
};
